import * as React from 'react';
import { noop } from '@amzn/storm-ui-utils';
import { ActivationResponse } from './ajaxPutActivationInfo';

type ActivationToggleType = {
  attachedComponent: string;
  activationResponse: ActivationResponse;
};

type AttributionContextProps = {
  activationToggleData: ActivationToggleType | null;
  setActivationToggleData: (args: ActivationToggleType | null) => void;
};

const AttributionContext = React.createContext<AttributionContextProps>({
  activationToggleData: null,
  setActivationToggleData: noop,
});

export const useAttributionContext = (): AttributionContextProps => {
  const context = React.useContext(AttributionContext);
  if (!context) {
    throw new Error('AttributionContext must be used with AttributionProvider');
  }
  return context;
};

export const AttributionProvider: React.FC = ({ children }) => {
  const [activationToggleData, setActivationToggleData] =
    React.useState<ActivationToggleType | null>(null);
  return (
    <AttributionContext.Provider
      value={{ activationToggleData, setActivationToggleData }}
    >
      {children}
    </AttributionContext.Provider>
  );
};
